define('modules/form/rtftextarea_view',[
    'backbone',
    'jquery',
    '_',

    './form_item_view',
    'modules/modal/modal_view',
    'text!./rtftextarea_template.html',
    'modules/form/modal/create_link_modal_view',
    'text!modules/form/media_fact_connection/media_fact_connection_template.html',
    ], function (
    Backbone,
    $,
    _,
    FormItemView,
    ModalView,
    template,
    CreateLinkModalView,
    media_fact_connection_template
) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      this.listenTo(this.model, 'change', this.renderMediaFactConnection);

      FormItemView.prototype.initialize.apply(this, options);

      var value = {};

      value[this.model.get('name')] = this.model.get('value');

      this.dataModel.set(value);
      this.dataModelAttributesOriginal = _.cloneDeep(this.dataModel.attributes);

      this.render();
      this.renderMediaFactConnection();

      Backbone.on('createLink', this.createLink, this);
    },
    media_fact_connection_template: _.template(media_fact_connection_template),
    events: {
      'input textarea': 'handleChange',
      'propertychange textarea': 'handleChange',
      'click .js-create-link': 'openCreateLinkModal',
    },

    handleChange: function (e) {
      var property = this.model.get('name');

      // TODO Check if url exists
      $(e.target).val();

      this.dataModel.set(property, $(e.target).val());

      if (this.model.get('media_fact_connection') === 'Connected') {
        this.model.set('media_fact_connection', 'WillDisconnect');
      }
      // Reset to 'Connected' if user changes back to the original value.
      else if (
        this.model.get('media_fact_connection') === 'WillDisconnect' &&
        ($(e.target).val() === this.dataModelAttributesOriginal[property] ||
          ($(e.target).val() === '' &&
            !this.dataModelAttributesOriginal[property]))
      ) {
        this.model.set('media_fact_connection', 'Connected');
      }
    },

    openCreateLinkModal: function (e) {
      e.preventDefault();
      var modal = new ModalView({
        title: _.t('formfield.rtftextarea.modal.create_link.title'),
        modalContent: new CreateLinkModalView(),
        bottom_toolbar: false,
      });
      modal.open();
    },

    createLink: function (link) {      
      var textarea = $('#textarea_id-' + this.model.get('name'));
      var cursorPos = textarea[0].selectionStart;
      var textBefore = textarea.val().substring(0, cursorPos);
      var textAfter = textarea.val().substring(cursorPos, textarea.val().length);    
      textarea.val(textBefore + link + textAfter);
      textarea.trigger('propertychange');
    },

    template: _.template(template),

    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(
        this.media_fact_connection_template(this.model.attributes)
      );
      return this;
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    remove: function () {
      Backbone.off('createLink');
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

